import { useId } from "react";
import { ChevronRight, Loader2 } from "lucide-react";
import { Link } from "wouter";

type RowProps = { title: string; description: string };

/** Presentation only: preference state and persistence stay with the existing owner. */
export function MobileSettingsSwitch({ title, description, checked, disabled, onChange }: RowProps & {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) {
  const id = useId();
  return <div className="settings-control-row">
    <span><strong id={`${id}-label`}>{title}</strong><small id={`${id}-description`}>{description}</small></span>
    <button type="button" role="switch" aria-checked={checked} aria-labelledby={`${id}-label`} aria-describedby={`${id}-description`} disabled={disabled} className="settings-switch" onClick={() => onChange(!checked)}>
      <span aria-hidden="true" />
    </button>
  </div>;
}

type ActionProps = RowProps & ({ href: string; onClick?: never; busy?: never; testId?: never } | {
  href?: never;
  onClick: () => void;
  busy?: boolean;
  testId?: string;
});

export function MobileSettingsAction(props: ActionProps) {
  const content = <><span><strong>{props.title}</strong><small>{props.description}</small></span>{props.busy ? <Loader2 className="animate-spin" aria-hidden="true" /> : <ChevronRight aria-hidden="true" />}</>;
  return props.href !== undefined
    ? <Link href={props.href} className="settings-control-row settings-control-action">{content}</Link>
    : <button type="button" className="settings-control-row settings-control-action" onClick={props.onClick} disabled={props.busy} aria-busy={props.busy} data-testid={props.testId}>{content}</button>;
}
